import './button.css'
const CustomButton1 = ({ text, onClick, classNamee }) => {
    return (
      <button 
        className={`custom-button ${classNamee}`} 
        onClick={onClick}
      >
        {text}
      </button>
    );
  };
  
export default CustomButton1;